import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import KendoGridColumn from '../KendoGridColumn'
import KendoGridToolbar from '../KendoGridToolbar'
import GridProps from './GridProps'
import AllowCopy from './AllowCopy'
import ColumnMenu from './ColumnMenu'
import Editable from './Editable'
import Excel from './Excel'
import Filterable from './Filterable'
import Groupable from './Groupable'
import Messages from './Messages'
import NoRecords from './NoRecords'
import Pageable from './Pageable'
import Pdf from './Pdf'
import Scrollable from './Scrollable'
import Sortable from './Sortable'

export default {
    props: GridProps,
    render (h) {
        return h('div',[this.$slots['kendo-datasource'],this.$slots.default])
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        AllowCopy,
        ColumnMenu,
        Editable,
        Excel,
        Filterable,
        Groupable,
        Messages,
        NoRecords,
        Pageable,
        Pdf,
        Scrollable,
        Sortable
    ],
    mounted() {
        this._resolveChildren()
        kendo.jQuery(this.$el).kendoGrid(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoGrid()
        },
        _resolveChildren () {
            this.resolveChildren('columns', KendoGridColumn.name)
            this.resolveChildren('toolbar', KendoGridToolbar.name)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGrid/KendoGridMixin.js